import Header from "./components/Layout/Header"
import Navigation from "./components/Layout/Navigation"
import { Outlet } from "react-router-dom"

import './index.css'

const TeacherCabinet = () => {
    return (
        <>
        <div className="max-w-[1440px] max-h-screen overflow-hidden w-full m-auto px-2 px-lg-0 min-h-screen flex flex-col text-blue-gray">
            <Header />
            <div className="flex grow relative">
                <Navigation />
                <div className="teachers-cabinet-content w-full">
                    <Outlet />
                </div>
            </div>
        </div>
        </>
    )
}

export default TeacherCabinet